import React from 'react'
import { MetricSeries, MessageConst } from 'enums'
import messageUtil from 'utils/messageUtil'

import PanelColumn from './PanelColumn'
import { resolveMetrics } from './utils'
import { NonNullableDataset } from './types'

interface TiktokPanelProps {
  data: NonNullableDataset
}

const TiktokPanel = ({ data }: TiktokPanelProps) => {
  const {
    engagements,
    views,
    reposts: shares,
    replies: comments,
    likes,
    impressions,
    netSentiment,
    positiveSentiment,
    negativeSentiment,
    passion
  } = resolveMetrics(data)
  return (
    <>
      <PanelColumn
        title={messageUtil.measureType(MetricSeries.TOTAL_ENGAGEMENTS)}
        value={engagements}
      />
      <PanelColumn title={messageUtil.measureType(MetricSeries.VIEWS)} value={views} />
      <PanelColumn title={messageUtil.measureType(MetricSeries.SHARES)} value={shares} />
      <PanelColumn title={messageUtil.measureType(MetricSeries.COMMENTS)} value={comments} />
      {likes !== MessageConst.EM_DASH && (
        <PanelColumn title={messageUtil.measureType(MetricSeries.LIKES)} value={likes} />
      )}
      <PanelColumn
        title={messageUtil.measureType(MetricSeries.IMPRESSIONS)}
        value={impressions === '0' ? MessageConst.EM_DASH : impressions}
      />
      {netSentiment !== MessageConst.EM_DASH && (
        <PanelColumn
          title={messageUtil.measureType(MetricSeries.NET_SENTIMENT)}
          value={`${netSentiment}%`}
        />
      )}
      {positiveSentiment !== MessageConst.EM_DASH && (
        <PanelColumn
          title={messageUtil.measureType(MetricSeries.POSITIVE_SENTIMENT)}
          value={positiveSentiment}
        />
      )}
      {negativeSentiment !== MessageConst.EM_DASH && (
        <PanelColumn
          title={messageUtil.measureType(MetricSeries.NEGATIVE_SENTIMENT)}
          value={negativeSentiment}
        />
      )}
      {passion !== MessageConst.EM_DASH && (
        <PanelColumn title={messageUtil.measureType(MetricSeries.PASSION)} value={passion} />
      )}
    </>
  )
}
export default TiktokPanel
